import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Response } from '../../models/response';

@Injectable({
  providedIn: 'root'
})
export class ShipmentService {
  constructor(private http: HttpClient) { }

  getBulk(){
    return this.http.get(`${environment.apiUrl}/shipment/bulk`, {})
    .pipe(map((data:any) => {
      return data;
    }));
  }

  getShipments($params = {}){
    return this.http.get(`${environment.apiUrl}/shipment/list`, { params : $params})
    .pipe(map((data:any) => {

      return data;
    }));
  }
  getAllmasterShipment($params = {}){
    return this.http.get(`${environment.apiUrl}/hmStorage/list`, { params : $params})
    .pipe(map((data:any) => {
      return data;
    }));
  }
  getArchivedShipments($params = {}){
    return this.http.get(`${environment.apiUrl}/shipment/hmArchive`, { params : $params})
    .pipe(map((data:any) => {

      return data;
    }));
  }

  getShippers(){
    return this.http.get(`${environment.apiUrl}/shipper/list`, {})
    .pipe(map((data:any) => {
      return data;
    }));
  }

  getReceivers(){
    return this.http.get(`${environment.apiUrl}/receiver/list`, {})
    .pipe(map((data:any) => {
      return data;
    }));
  }

  updateHistoryItem(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/updatehistoryitem`, formData, { observe: 'events',  reportProgress: true });
  }
  updateBusinessAccounting(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/update`, formData, { observe: 'events',  reportProgress: true });
  }
  updateMasterShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/update`, formData, { observe: 'events',  reportProgress: true });
  }

  downloadHistoryItem(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/downloadgallery`, formData);
  }
  saveMasterShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/save`, formData, { observe: 'events',  reportProgress: true });
  }
  deleteHistoryItem(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/deletehistoryitem`, formData);
  }

  saveShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/save`, formData, { observe: 'events',  reportProgress: true });
  }

  saveShipmentNotes(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/savenote`, formData);
  }

  getShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/get`, formData);
  }
  getBusinessAccounting(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/getItem`, formData);
  }
  getMasterShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/getItem`, formData);
  }

  getVin(formData: FormData): Observable<any>{
    return this.http.post(`${environment.apiUrl}/shipment/getVinData`, formData);
  }

  getShipmentHistory(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/history`, formData);
  }

  getShipmentFiles(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/files`, formData);
  }
  getShipmentMasterFiles(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/files`, formData);
  }
  getBusinessAccountsFiles(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/files`, formData);
  }


  saveShipmentFiles(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/savefiles`, formData, { observe: 'events',  reportProgress: true });
  }
  saveMasterShipmentFiles(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/savefiles`, formData, { observe: 'events',  reportProgress: true });
  }
  saveBusinessAccountingFiles(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/savefiles`, formData, { observe: 'events',  reportProgress: true });
  }

  deleteShipmentFile(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/deletefile`, formData);
  }

  deleteMasterShipmentFile(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/deletefile`, formData);
  }
  deleteBusinessAccountingFile(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/deletefile`, formData);
  }

  deleteShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/shipment/delete`, formData);
  }
  deleteMasterShipment(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmStorage/delete`, formData);
  }
  //Accounting Business service
  saveAccountingBusiness(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/save`, formData, { observe: 'events',  reportProgress: true });
  }
  getAllBusinessAccounts($params = {}){
    return this.http.get(`${environment.apiUrl}/hmProfitLoss/list`, { params : $params})
    .pipe(map((data:any) => {
      return data;
    }));
  }
  deleteBusinessAccount(formData: FormData): Observable<any> {
    return this.http.post(`${environment.apiUrl}/hmProfitLoss/delete`, formData);
  }
}
